module.exports = __webpack_public_path__ + "img/9788954642149.709513a3.jpg";